import React from 'react';
import { User } from 'lucide-react';

/**
 * Shared technician filter dropdown.
 *
 * Values: 'all' | 'f:franchiseeId' | 'franchiseeId:branchId'
 */
const TechnicianFilter = ({ techGroups, selectedTechnician, setSelectedTechnician, showFilter, isAdmin, className = '', compact = false }) => {
  if (!showFilter) return null;

  return (
    <div className={`relative inline-flex items-center ${className}`}>
      <User size={compact ? 14 : 16} className={`absolute left-2.5 text-pest-blue pointer-events-none z-10`} />
      <select
        value={selectedTechnician}
        onChange={(e) => setSelectedTechnician(e.target.value)}
        className={compact
          ? 'appearance-none pl-8 pr-6 py-1.5 text-xs font-medium text-gray-800 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-pest-blue focus:border-pest-blue max-w-[140px] cursor-pointer'
          : 'appearance-none pl-9 pr-8 py-2 text-sm font-medium text-gray-800 bg-white border border-gray-300 rounded-lg shadow-sm hover:border-pest-blue focus:outline-none focus:ring-2 focus:ring-pest-blue focus:border-pest-blue min-w-[200px] cursor-pointer'
        }
      >
        {isAdmin && <option value="all">{compact ? 'All Techs' : 'All Technicians'}</option>}
        {techGroups.map(group => (
          <optgroup key={group.id} label={group.company || group.name}>
            <option value={`f:${group.id}`}>{group.name} (All)</option>
            <option value={`${group.id}:${group.branchId}`}>{group.name}</option>
            {group.technicians.map(tech => (
              <option key={tech.id} value={`${group.id}:${tech.branchId}`}>{tech.name}</option>
            ))}
          </optgroup>
        ))}
      </select>
      <svg className={`absolute ${compact ? 'right-1.5' : 'right-2.5'} pointer-events-none text-gray-400`} width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  );
};

export default TechnicianFilter;
